import api from "../axiosConfig"

const resource = "/users"

export default {
  async getAll() {
    const { data } = await api.get(`${resource}`, {
      params: {
        "sort[0]": "username",
      },
    })
    return data
  },

  async getAllByName(nome, papel = undefined) {
    let params = {
      "sort[0]": "username",
    }

    if (papel && nome) {
      params = Object.assign(params, {
        "filters[$and][0][username][$containsi]": nome,
        "filters[$and][1][role][name][$eq]": papel,
      })
    } else if (papel) {
      params = Object.assign(params, {
        "filters[role][name][$eq]": papel,
      })
    } else {
      params = Object.assign(params, {
        "filters[username][$containsi]": nome,
      })
    }

    const { data } = await api.get(`${resource}`, { params })
    return data
  },

  async getOne(id) {
    return api.get(`${resource}/${id}`)
  },

  async update(payload) {
    return api.put("user/me", payload)
  },

  async changePassword(payload) {
    return api.post("auth/change-password", payload)
  },
}
